<cap-oereb-wrapper
  [gsId]="gsId"
  [hasData]="hasData"
  [oerebServiceNichtVerfuegbar]="oerebServiceNichtVerfuegbar"
  [stockwerkOrMiteigentum]="stockwerkOrMiteigentum">
  @if (stammgrundstueck$ | async; as stammgrundstueck) {
    <p>
      {{ "oereb.datenVonGrundstueck:" | translate }}
      <cap-kompakt-grundstueck [item]="stammgrundstueck" [navigateTo]="navTargets.NAV_GRUNDSTUECK_OEREB"></cap-kompakt-grundstueck>
    </p>
  }
  @for (listLoader of listLoaders; track listLoader; let i = $index) {
    <div class="mt-3">
      <cap-list-loader [listLoader]="listLoader" [showTotal]="false" keineTranslateKey="oereb.KeineOderNochKeineDatenVorhanden">
        <div class="cap-list-loader-title">
          @if (i === 0) {
            <h3>{{ "oereb.oerebsBetreffenGrundstueck" | translate }}</h3>
          }
          @if (i === 1) {
            <h3>{{ "oereb.oerebsBetreffenGrundstueckNicht" | translate }}</h3>
          }
          @if (i === 2) {
            <h3>{{ "oereb.oerebsKeineDatenVorhanden" | translate }}</h3>
          }
        </div>
        <div class="cap-list-loader-content">
          <table class="cap-table-detail">
            <tbody>
              @for (line of listLoader?.items; track line) {
                <tr>
                  <td>{{ line }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </cap-list-loader>
    </div>
  }
</cap-oereb-wrapper>
